export const TRANSFER_METHODS = [
  { id: 'vodafone', label: 'Vodafone Cash' },
  { id: 'instapay', label: 'InstaPay' },
];

export const PAYMENT_KEYS = ['whatsapp', 'vodafone', 'instapay'];

export function waLink(number, text) {
  const digits = String(number ?? '').replace(/\D/g, '');
  if (digits.length < 10) return '';
  const international = digits.startsWith('20') ? digits : `20${digits.replace(/^0/, '')}`;
  return `https://wa.me/${international}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
}
